<template>
  <v-card>
    <v-dialog v-model="showInfo" max-width="320px">
      <v-card>
        <v-card-title>Collected Info</v-card-title>
        <v-card-text>
          <div><strong>Name: </strong> {{info.name}}</div>
          <div><strong>Email: </strong> {{info.email}}</div>
          <div><strong>Phone: </strong> {{info.phone}}</div>
          <div><strong>Street: </strong> {{info.street}}</div>
          <div><strong>City: </strong> {{info.city}}</div>
          <div><strong>Zipcode: </strong> {{info.zipcode}}</div>
          <div><strong>Make: </strong> {{info.make}}</div>
          <div><strong>Model: </strong> {{info.model}}</div>
          <div><strong>Year: </strong> {{info.year}}</div>
          <div><strong>Vin: </strong> {{info.vin}}</div>
          <div><strong>Warranty: </strong> {{info.warranty}}</div>
          <div><strong>Payment: </strong> {{info.payment}}</div>
          <div><strong>Reference: </strong> {{info.reference}}</div>

        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-text-field v-model="number" label="Enter Customer Number" type="tel"></v-text-field>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save" :loading="sending">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-btn
        color="primary"
        class="mr-4"
        @click="dialog = true"
        rounded
      >
        Send Link
      </v-btn>
      <v-btn icon text @click="getItems">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        clearable
        dense
        filled
        outlined
        rounded
      ></v-text-field>
    </v-card-title>
    <v-data-table 
      :headers="headers"
      :items="list" 
      :loading="loading"
      :server-items-length="totalItems"
      :options.sync="options"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon text @click="viewItem(item)">
          <v-icon small>remove_red_eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api from "@/api";
// import { debounce } from "lodash";
export default {
  name: "CollectInfo",
    data: () => ({
      totalItems: 0,
      dialog: false,
      loading: false,
      options: {},
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'id',
        },
        { text: 'Name', value: 'name' },
        { text: 'City', value: 'city' },
        { text: 'Phone', value: 'phone' },
        { text: 'Make', value: 'make' },
        { text: 'Year', value: 'year' },
        { text: 'Total', value: 'total' },
        { text: 'Vin', value: 'vin' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      list: [],
      search: '',
      formTitle: "Send Link",
      number: '',
      sending: false,
      showInfo: false,
      info: {},
    }),

    watch: {
      options: {
        handler () {
          this.getItems()
        },
        deep: true,
      },
      search() {
        this.getItems()
      }
    },
    methods: {
      initialize () {
        this.getItems()
      },

      async getItems() {
        const { page = 0, itemsPerPage = 10 } = this.options
        this.loading = true;
        const response = await api.getAppointments(this.search, itemsPerPage, page);
        this.totalItems = response.data.count;
        this.list = response.data.data;
        this.loading = false;
      },
      close() {
        this.dialog = false;
      },
      async save() {
        if(this.number && this.number.toString().length >= 10) {
          this.sending = true;
          await api.sendMessage(this.number)
          this.sending = false;
          this.close();
        }
      },
      viewItem(item) {
        this.info = item;
        this.showInfo = true;
      }
    },
  mounted() {
    
  }
};
</script>